import { useMutation, useQueryClient } from '@tanstack/react-query'
import { addRequirementQuestion } from 'api/requirements/addRequirementQuestion'
import { requirementKeys } from './keys'

type Response = Awaited<ReturnType<typeof addRequirementQuestion>>
type Variables = Omit<
  Parameters<typeof addRequirementQuestion>[0],
  'requirementId'
>

export const useAddRequirementQuestionMutation = (requirementId: number) => {
  const queryClient = useQueryClient()

  return useMutation<Response, Error, Variables>({
    mutationFn: (data) =>
      addRequirementQuestion({
        requirementId,
        ...data,
      }),
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: requirementKeys.detail(requirementId),
      })
    },
  })
}
